import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_DischargeSummary = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_DischargeSummary' className='file-pdf-document'>
            <div className='file-template'>
            <p className='750'>
    <input type='checkbox' id='cbDischargeSummary' name='cbDischargeSummary' className='add-only' value='DischargeSummary' /> Discharge Summary
</p>
<p className='750'>
    <span className='eleHeader'>PROGRAM(S):</span>
    <input type='checkbox' id='cbProgram_1' name='cbProgram_1' className='add-only' value='Program_1'/> TARGETED CASE MANAGEMENT
				<br />
    <input type='checkbox' id='cbProgram_2' name='cbProgram_2' className='add-only' value='Program_2'/> OUTPATIENT THERAPY
				<br />
    <input type='checkbox' id='cbProgram_3' name='cbProgram_3' className='add-only' value='Program_3'/> PSYCHOSOCIAL REHABILITATION
</p>

<table>
    <tr>
        <td className='w-250'><span className='eleHeader'>Client:</span></td>
        <td className='w-250'><span className='eleHeader'>DOB:</span></td>
        <td className='w-250'><span className='eleHeader'>CID#:</span></td>
    </tr>
    <tr>
        <td className='w-250'>
            <input type='text' id='txtClient' name='txtClient' className='add-only'/>
        </td>
        <td className='w-250'>
            <input type='date' id='txtDob' name='txtDob' className='add-only' />
        </td>
        <td className='w-250'>
            <input type='text' id='txtCid' name='txtCid' className='add-only'/>
        </td>
    </tr>
    <tr>
        <td className='w-250'><span className='eleHeader'>SS#:</span></td>
        <td className='w-250'><span className='eleHeader'>Admission Date:</span></td>
        <td className='w-250'><span className='eleHeader'>Date of Last Contact:</span></td>
    </tr>
    <tr>
        <td className='w-250'>
            <input type='text' id='txtSs' name='txtSs' className='add-only' />
        </td>
        <td className='w-250'>
            <input type='date' id='txtAdmissionDate' name='txtAdmissionDate' className='add-only' />
        </td>
        <td className='w-250'>
            <input type='date' id='txtDateLastContact' name='txtDateLastContact' className='add-only' />
        </td>
    </tr>
    <tr>
        <td className='w-250'><span className='eleHeader'>Termination Date:</span></td>
        <td className='w-250'><span className='eleHeader'>Therapist:</span></td>
        <td className='w-250'><span className='eleHeader'>Community Support:</span></td>
    </tr>
    <tr>
        <td className='w-250'>
            <input type='date' id='txtTerminationDate' name='txtTerminationDate' className='add-only'/>
        </td>
        <td className='w-250'>
            <input type='text' id='txtTherapist' name='txtTherapist' className='add-only'/>
        </td>
        <td className='w-250'>
            <input type='text' id='txtCommunitySupport' name='txtCommunitySupport' className='add-only'/>
        </td>
    </tr>
</table>
<p className='750'>
    <span className='eleHeader'>REASON FOR DISCHARGE:</span>
    <textarea id='txtReasonDischarge' name='txtReasonDischarge' className='add-only'></textarea>
</p>
<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Termination Status:</span></td>
    </tr>
    <tr>
        <td className='w-750'>
            <input type='checkbox' id='cbTerminationStatusDischarge' name='cbTerminationStatusDischarge' className='add-only' value='TerminationStatusDischarge' />Discharge</td>
    </tr>
</table>
<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Prognosis:</span></td>
    </tr>
    <tr>
        <td className='w-150'>
            <input type='checkbox' id='cbPrognosis_1' name='cbPrognosis_1' className='add-only' value='Prognosis_1' /> Good</td>
        <td className='w-150'>
            <input type='checkbox' id='cbPrognosis_2' name='cbPrognosis_2' className='add-only' value='Prognosis_2' /> Fair</td>
        <td className='w-150'>
            <input type='checkbox' id='cbPrognosis_3' name='cbPrognosis_3' className='add-only' value='Prognosis_3' /> Poor</td>
        <td className='w-150'>
            <input type='checkbox' id='cbPrognosis_4' name='cbPrognosis_4' className='add-only' value='Prognosis_4' /> Guarded</td>
        <td className='w-150'>
            <input type='checkbox' id='cbPrognosis_5' name='cbPrognosis_5' className='add-only' value='Prognosis_5' /> Not estimated</td>
    </tr>
</table>
<table>
    <tr>
        <td className='w-750'><span className='eleHeader'>Reason for Discontinuation: </span></td>
    </tr>
    <tr>
        <td className='w-250'>
            <input type='checkbox' id='cbDiscontinuation_1' name='cbDiscontinuation_1' className='add-only' value='Discontinuation_1' /> Client Died</td>
        <td className='w-250'>
            <input type='checkbox' id='cbDiscontinuation_2' name='cbDiscontinuation_2' className='add-only' value='Discontinuation_2' /> Client Transferred</td>
        <td className='w-250'>
            <input type='checkbox' id='cbDiscontinuation_3' name='cbDiscontinuation_3' className='add-only' value='Discontinuation_3' /> Client Completed Goals</td>
    </tr>
    <tr>
        <td className='w-250'>
            <input type='checkbox' id='cbDiscontinuation_4' name='cbDiscontinuation_4' className='add-only' value='Discontinuation_4' /> Client Withdrew</td>
        <td className='w-250'>
            <input type='checkbox' id='cbDiscontinuation_5' name='cbDiscontinuation_5' className='add-only' value='Discontinuation_5' /> Client Moved</td>
        <td className='w-250'>
            <input type='checkbox' id='cbDiscontinuation_6' name='cbDiscontinuation_6' className='add-only' value='Discontinuation_6' /> Unable to Locate</td>
    </tr>
    <tr>
        <td className='w-250'>
            <input type='checkbox' id='cbDiscontinuation_7' name='cbDiscontinuation_7' className='add-only' value='Discontinuation_7' /> Evaluation Only</td>
        <td className='w-250'>&nbsp;</td>
        <td className='w-250'>&nbsp;</td>
    </tr>
    <tr>
        <td className='w-250'>
            <input type='checkbox' id='cbDiscontinuation_8' name='cbDiscontinuation_8' className='add-only' value='Discontinuation_8' /> Other Services</td>
        <td className='w-250'>&nbsp;</td>
        <td className='w-250'>&nbsp;</td>
    </tr>
    <tr>
        <td className='w-750'>
            <input type='text' id='txtDiscontinuation_8' name='txtDiscontinuation_8' className='add-only' /></td>
        
    </tr>
    <tr>
        <td className='w-750'>
            <input type='checkbox' id='cbDiscontinuation_9' name='cbDiscontinuation_9' className='add-only' value='Discontinuation_9' /> Administrative Decision (explain)</td>
    </tr>
</table>

<p className='750'>
    <textarea id='txtDiscontinuation_9' name='txtDiscontinuation_9' className='add-only'></textarea>
</p>
<p className='750'>
    <span className='eleHeader'>Medication Profile:</span>
    <textarea id='txtMedicationProfile' name='txtMedicationProfile' className='add-only'></textarea>
</p>
<p className='750'>
    <strong>Termination Diagnosis (code, narrative):</strong>
</p>
<table>
    <tr>
        <td className='w-150'><span className='eleHeader'>Status</span></td>
        <td className='w-250'><span className='eleHeader'>Date</span></td>
        <td className='w-350'><span className='eleHeader'>DSM V (ICD 10) Description or Narrative</span></td>
    </tr>
    <tr>
        <td className='w-150'>Admission </td>
        <td className='w-250'>
            <input type='date' id='txtDate_1' name='txtDate_1' className='add-only'/></td>
        <td className='w-350'>
            <input  type='text' id='txtDescription_1' name='txtDescription_1' className='add-only'/></td>
    </tr>
    <tr>
        <td className='w-150'>Discharge </td>
        <td className='w-250'>
            <input type='date' id='txtDate_2' name='txtDate_2' className='add-only'/></td>
        <td className='w-350'>
            <input  type='text' id='txtDescription_2' name='txtDescription_2' className='add-only'/></td>
    </tr>
</table>
<p className='750'>
    <span className='eleHeader'>Summary of Services/Treatment: </span>
    <span className='small'>(strength, abilities, challenges/needs, preferences, family involvement)</span>
    <textarea id='txtSummaryServices' name='txtSummaryServices' className='add-only'></textarea>
</p>
<p className='750'>
    <span className='eleHeader'>Recommendations</span>
    <span className='small'>(ex. Continue services, etc.)</span>
    <textarea id='txtRecommendations' name='txtRecommendations' className='add-only'></textarea>
</p>
<p className='750'>
    <span className='eleHeader'>Follow Up/Referral Source:</span>
    <span className='small'>(please list agency name, contact person & phone #)</span>
    <textarea id='txtFollowUp' name='txtFollowUp' className='add-only'></textarea>
</p>
<p className='750'>
    <span className='eleHeader'>Disposition Status:</span>
    <span className='small'>(Describe client's status of discharge.  Ex. Living home, unable to locate, met all goals, etc.)</span>
    <textarea id='txtDispositionStatus' name='txtDispositionStatus' className='add-only'></textarea>
</p>

<p className='750'>
    *Note:  Discharge Summary must be complete within the specified time period.
</p>


                
            </div>
        </form>

    )
}











